import { create } from "zustand";

interface WriteErrorState {
  message: string | null;
  /** Bumped on every `show` so an identical repeat still replays and re-announces. */
  seq: number;
  show: (message: string) => void;
  dismiss: () => void;
}

/** A single slot, not a queue, so a burst of failures can't stack into a wall of notices. */
export const useWriteErrorStore = create<WriteErrorState>((set) => ({
  message: null,
  seq: 0,
  show: (message) => set((s) => ({ message, seq: s.seq + 1 })),
  dismiss: () => set({ message: null }),
}));
